import React from 'react'

import { Box } from 'system'

export const FloatingCard = ({ children, ...props }) => (
  <Box
    border="2px solid"
    borderColor="purple.90"
    borderRadius="4px"
    color="gray.60"
    height="100%"
    lineHeight="copy"
    pyScale="m-"
    pxScale="m"
    position="relative"
    transitionProperty="border-color, color"
    css={`
      &:hover {
        border-color: ${p => p.theme.colors.purple[50]};
        color: ${p => p.theme.colors.gray[40]};
      }
    `}
    {...props}
  >
    {children}
  </Box>
)
